import React, {Component} from 'react'
import {Button, Icon, Modal,} from 'semantic-ui-react'

class UpdateAvailableModal extends Component {
	render() {
		return (
			<Modal size='tiny' open={true}>
				<Modal.Header>
					Hay una nueva versión de la web disponible
				</Modal.Header>
				<Modal.Content>
					<Button primary fluid onClick={() => window.location.reload()}><Icon
						name='refresh'/>Actualizar</Button>
				</Modal.Content>
			</Modal>
		);
	}
}

export default UpdateAvailableModal;



// WEBPACK FOOTER //
// ./src/common/UpdateAvailableModal.js